import { useUnit } from 'effector-react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from 'src/components/sidebar';

import { Stack, lighten } from '@mui/material';

import { ConfirmDialog } from '@components/dialogConfirm';
import { Header } from '@components/header';
import { Servicing } from '@components/layouts/main/servicing';
import { LoaderBackdrop } from '@components/loader/loaderBackdrop';
import { NotificationDrawer } from '@components/notificationDrawer';

import { useMnemonics } from '@hooks/useMnemonics';

import { AppContextProvider } from '@system/app/provider';
import {
  $isSidebarCollapsed,
  setIsSidebarCollapsed,
} from '@system/app/store/sidebarCollapsed.store';
import { Subscriptions } from '@system/subscriptions';

export const MainLayout = () => {
  // TODO Удалить после перехода на новые таблицы
  // Костыль, который чинит проблему исчезновения таблиц, в которых используется
  // этот хук (вероятно, влияет на suspense)
  useMnemonics();

  const isSidebarCollapsed = useUnit($isSidebarCollapsed);

  return (
    <AppContextProvider>
      <Suspense fallback={<LoaderBackdrop />}>
        <Header isSidebarCollapsed={isSidebarCollapsed} />
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            position: 'relative',
          }}
          data-testid="main-layout"
        >
          <Sidebar
            isCollapsed={isSidebarCollapsed}
            setIsCollapsed={setIsSidebarCollapsed}
          />
          <Stack
            data-testid="main-contentainer"
            sx={{
              pt: 0,
              flex: '1 1 auto',
              maxHeight: 'calc(100vh - 40px)',
              overflowY: 'auto',
              mt: 5,
              '&::-webkit-scrollbar': {
                background: lighten('#394A58', 0.8),
                width: '10px',
              },
              '&::-webkit-scrollbar-track': {
                background: lighten('#394A58', 0.8),
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#394A58',
                borderRadius: 2,
              },
            }}
          >
            <Servicing>
              <Outlet />
            </Servicing>
          </Stack>
        </Stack>

        <Subscriptions />
        <ConfirmDialog />
        <NotificationDrawer />
      </Suspense>
    </AppContextProvider>
  );
};
